export default (theme) => {
  return {
    container: {
      alignItems: 'center',
      display: 'flex',
      minHeight: `calc(100vh - ${theme.mixins.toolbar['@media (min-width:600px)'].minHeight}px)`,
      justifyContent: 'center',
      margin: `${theme.mixins.toolbar['@media (min-width:600px)'].minHeight}px 10px 0px`,

      [theme.breakpoints.down('xs')]: {
        minHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
        margin: `${theme.mixins.toolbar.minHeight}px 0px 0px`,
        width: '100%',
      },
    },
  };
};
